import styled from 'styled-components'
import { Button as AntButton } from 'antd'

/**
 * Styled components for SignUpForm component
 * Replaces inline styles with reusable styled components
 */

// Full width button
export const FullWidthButton = styled(AntButton)`
  width: 100%;
`
